import { useEffect } from 'react';
import RestUtilities from '../services/RestUtilities';
import { artistsState, loadingState } from '../state/RecoilState';
import { useRecoilState, useSetRecoilState } from 'recoil';

export const useGetAllArtists = () => {
  const setLoading = useSetRecoilState(loadingState);
  const [artists, setArtists] = useRecoilState(artistsState);
  useEffect(() => {
    const getArtists = async () => {
      setLoading(true);
      const res = await RestUtilities.get('/api/artist/Get');
      if (res.ok) {
        setArtists(res.content);
      }
      setLoading(false);
    };
    if (artists.length === 0) {
      getArtists();
    }
  }, [artists.length, setArtists, setLoading]);
};
